<template>
  <div class="main-container min-vh-100 w-100">
    <div class="close-container">
      <CButton @click="onClose">
        <font-awesome-icon :icon="['fas', 'times']" />
      </CButton>
    </div>
    <div ref="summary-container" class="summary-box">
      <div
        v-for="(item, index) in progress"
        :key="index"
        class="criteria-panel mb-4"
      >
        <div v-if="item.percent > 0">
          <div class="table-title">
            {{ $helpers.translate(item.description, lang) }}
          </div>

          <div class="p-4">
            <CRow v-for="(subItem, subIndex) in item.condition" :key="subIndex">
              <CCol md="6">
                {{ $helpers.translate(subItem.name, lang) }}
              </CCol>

              <CCol md="6" class="my-auto position-relative pr-5">
                <CProgress
                  class="progress-bar"
                  :value="(subItem.val / subItem.maxVal) * 100"
                  :max="100"
                  :showValue="false"
                  border-radius="50px"
                >
                  <CProgressBar></CProgressBar>
                </CProgress>
                <span class="position-absolute text-progress">{{
                  ((subItem.val / subItem.maxVal) * 100).toFixed(1)
                }}</span>
              </CCol>
            </CRow>
          </div>
        </div>
      </div>
      <div class="text-center mb-5 mt-5">
        <button class="btn btn-cpr btn-next" @click="onNext">
          {{ $helpers.translate(actionNext.title, lang) }}&nbsp;>>>
        </button>
      </div>
    </div>
    <div class="cartoon-image-container">
      <img v-if="mascot" :src="mascot" />
    </div>
  </div>
</template>
<script src="path/to/chartjs/dist/Chart.js"></script>
<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Summaryall',
  data() {
    return {
      mascot: '',
      item: [],
      actionClose: '',
      actionNext: '',
      lang: 'th',
      courseCode: '',
      content: [],
      progress: [],
      next: '',
      templateId: '',
      startTime: '',
      courseSection: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      lang: 'th',
    };
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      else return value.toUpperCase();
    },
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      // templateContent: 'template/getTemplateContent',
      getCourseProgress: 'courses/getCourseChapterAndProgress',
    }),
  },
  created() {
    this.courseCode = this.$store.getters['necessary/getLerningCourse'];
    this.startTime = this.$helpers.getDateFormat();
  },

  watch: {
    getCourseProgress: function (val) {
      this.progress = val.template;
    },
    getTemplatev3(val) {
      const template = val.templates[0];

      if (!template.enable) {
        this.$router.push({name: 'v4' + template.navigate.close.action});
      } else {
        var containerWidth = 0;
        this.courseSection = this.$store.getters['necessary/getLerningCourse'];
        this.templateId = template._id;
        this.mascot = this.baseUrl + '/cpr/Image/' + template.content.image;
        this.actionClose = template.navigate.close;
        this.actionNext = template.navigate.next;
        this.next = template.navigate.next.action;
        this.content = template.content;
        //need to change
        this.$store.dispatch(
          'courses/fetchCourseChapterAndProgress',
          this.courseCode
        );
      }
    },

    // templateContent: function (val) {
    //   if (!val.enable) {
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     var containerWidth = 0;
    //     this.courseSection =
    //       this.$store.getters['necessary/getLerningCourse'].groups[0].code;
    //     this.templateId = val._id;
    //     this.mascot = this.baseUrl + '/cpr/Image/' + val.content.image;
    //     this.actionClose = val.navigate.close;
    //     this.actionNext = val.navigate.next;
    //     this.next = val.navigate.next.action;
    //     this.content = val.content;
    //     this.$store.dispatch(
    //       'courses/fetchCourseChapterAndProgress',
    //       this.courseCode
    //     );
    //     // this.$store.dispatch('template/createUserTemplateData', {
    //     //   code: this.courseCode,
    //     //   template: val._id,
    //     //   section: this.courseSection,
    //     // });
    //   }
    // },
  },
  mounted() {
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = 'CPR-E52';
    // this.$store.dispatch('template/fetchContent', body);

    const templateCode = 'CPR-E52';

    this.$store.dispatch('v3/fetchTemplateByCode', templateCode);
  },
  methods: {
    onNext() {
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.templateId,
      //   section: this.courseSection,
      //   answering: [],
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: [],
      // });

      this.$router.push({
        name: 'v4' + this.next,
      });
    },
    onClose() {
      this.$router.push({
        name: 'v4' + this.actionClose.action,
      });
    },
  },
};
</script>
<style scoped>
@import '../../../assets/scss/CPR/style.scss';
.cartoon-image-container {
  position: absolute;
  left: 10%;
  top: 30%;
  width: 20rem;
  height: auto;
}
.cartoon-image-container img {
  object-fit: fill;
  width: 100%;
  height: 100%;
  max-width: auto;
  max-height: auto;
}
.close-container {
  text-align: center;
  position: absolute;
  top: 15%;
  right: 5%;
  z-index: 9;
  background: transparent
    linear-gradient(139deg, #d9d9d9 0%, var(--unnamed-color-e2e2e2) 100%) 0% 0%
    no-repeat padding-box;
  background: transparent linear-gradient(139deg, #d9d9d9 0%, #e2e2e2 100%) 0%
    0% no-repeat padding-box;
  box-shadow: -2px -2px 5px #ffffff80;
  border: 1px solid #ffffff40;
  opacity: 0.8;
  border-radius: 50%;
}
@media screen and (max-width: 1440px) {
  .cartoon-image-container {
    left: 0;
    top: 30%;
  }
}
@media screen and (max-width: 768px) {
  .cartoon-image-container {
    left: -1rem;
    width: 12rem;
    height: 24rem;
  }
}
@media screen and (max-width: 480px) {
  .cartoon-image-container {
    position: absolute;
    left: -2rem;
    bottom: 0rem;
    width: 12rem;
    height: 20rem;
  }
}
.table-title {
  background: var(--unnamed-color-e2e2e2) 0% 0% no-repeat padding-box;
  background: #e2e2e2 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 10px #00000033;
  opacity: 1;
  font-size: 26px;
  padding: 1rem 2rem 1rem 2rem;
  border-radius: 80px;
}
.main-container .summary-box {
  text-align: left;
  padding: 20px;
  position: relative;
  margin: 10% auto !important;
  width: 80vh;
  height: auto;
  min-width: 600px;
  min-height: 600px;
}
.main-container {
  overflow-y: hidden;
  overflow-x: hidden;
  padding-top: 3rem;
  left: 0px;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: auto;
  /* background: transparent linear-gradient(224deg, #ffffff00 0%, #00000038 100%)
    0% 0% no-repeat padding-box; */
  background: #f3f3f3;
}
.criteria-panel {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #efefef 0% 0% no-repeat padding-box;
  border-radius: 40px;
  font-size: 20px;
}
.progress {
  background: #fff;
  border-radius: 50px;
}
.progress .progress-bar {
  border-radius: 50px;
  background-color: rgb(56, 173, 174);
  height: 100%;
}
.text-progress {
  right: 5px;
  top: 0;
  font-size: 16px;
  margin-top: -5px;
}
.bg-green {
  background-color: #38adae !important;
}
</style>
